import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/CREATE_FORM";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setFormsList: (state, action) => {
            state.formsList = action.payload;
        },
        setPayerList: (state, action) => {
            state.payerList = { ...state.payerList, ...action.payload };
        },
        setRecipientList: (state, action) => {
            state.recipientList = { ...state.recipientList, ...action.payload };
        },
        setToCreateFormData: (state, action) => {
            state.toCreateFormData = { ...state.toCreateFormData, ...action.payload };
        },
        setIsYearFormTypeSelected: (state, action) => {
            state.isYearFormTypeSelected = action.payload;
        },
        setFormBoxesList: (state, action) => {
            state.formBoxesList = action.payload;
        },
        setFormFieldsList: (state, action) => {
            state.formFieldsList = action.payload;
        },
        setTempFormFieldsList: (state, action) => {
            state.tempFormFieldsList = [...action.payload];
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setRecipientListLoadingState: (state, action) => {
            state.recipientListLoadingState = action.payload;
        },
        setOnDependentFields: (state, action) => {
            state.onDependentFields = action.payload;
        },
        setUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = action.payload;
        },
        updateUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {
                ...state.userInteractionPopupWResponseObj,
                ...action.payload,
            };
        },
        resetUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {};
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        setIsIRSViewOn: (state, action) => {
            state.isIRSViewOn = action.payload;
        },
        setReloadFormsPreLoadedData: (state, action) => {
            state.reloadFormsPreLoadedData = action.payload;
        },
        setIsStepperViewAvailable: (state, action) => {
            state.isStepperViewAvailable = action.payload;
        },
        setIsIRSViewAvailable: (state, action) => {
            state.isIRSViewAvailable = action.payload;
        },
        setShouldLoadNextFormInSeries: (state, action) => {
            state.shouldLoadNextFormInSeries = action.payload;
        },
        setNxtFormInSeriesDetails: (state, action) => {
            state.nxtFormInSeriesDetails = action.payload;
        },
        setPrevFormInSeriesDetails: (state, action) => {
            state.prevFormInSeriesDetails = action.payload;
        },
        setFormDataFromRecordId: (state, action) => {
            state.formDataFromRecordId = action.payload;
        },
        setIsIncorrectFormRecordId: (state, action) => {
            state.isIncorrectFormRecordId = action.payload;
        },
        setFormsInSeriesHistory: (state, action) => {
            state.formsInSeriesHistory = action.payload;
        },
        setInitialInteractionPopupWObj: (state, action) => {
            state.initialInteractionPopupWObj = action.payload;
        },
        setElementToBeFocused: (state, action) => {
            state.elementToBeFocused = action.payload;
        },
        setStepperRefreshStep: (state, action) => {
            state.stepperRefreshStep = action.payload;
        },
        setHelpTextObj: (state, action) => {
            state.helpTextObj = action.payload;
        },
        updateHelpTextObj: (state, action) => {
            state.helpTextObj = {
                ...state.helpTextObj,
                ...action.payload,
            };
        },
        setShowHelpPopup: (state, action) => {
            state.showHelpPopup = action.payload;
        },
        setSelect1099Forms: (state, action) => {
            state.isSelect1099Forms = action.payload;
        },        
        setStateNamesList: (state, action) => {
            state.stateNamesList = action.payload;           
        },
        setSelectedStateName: (state, action) => {
            state.selectedStateName = action.payload;
        },
        setStatePayrollFormsList: (state, action) => {
            state.statePayrollFormsList = action.payload;
        },        
    }, 
    initialReducerState: {
        formsList: {},
        payerList: {
            data: []
        },
        recipientList: {
            data: []
        },
        formBoxesList: {
            data: []
        },
        formFieldsList: {
            data: []
        },
        toCreateFormData: {
            selectedYear: null,
            selectedForm: null,
            selectedPayer: null,
            selectedRecipient: null,
            isFormEditMode: null,
        },

        tempFormFieldsList: [],
        isYearFormTypeSelected: false,
        loadingState: false,
        recipientListLoadingState: false,
        onDependentFields: {},
        userInteractionPopupWResponseObj: {},
        formsPreLoadedData: {},
        isIRSViewOn: false,
        reloadFormsPreLoadedData: false,
        isStepperViewAvailable: true,
        isIRSViewAvailable: true,
        shouldLoadNextFormInSeries: null,
        nxtFormInSeriesDetails: null,
        prevFormInSeriesDetails: null,
        formsInSeriesHistory: [],
        formDataFromRecordId: null,
        isIncorrectFormRecordId: null,
        initialInteractionPopupWObj: {},
        elementToBeFocused: null,

        stepperRefreshStep: 0,
        showHelpPopup: false,
        helpTextObj: {},
        isSelect1099Forms: true, 
        stateNamesList: {},
        selectedStateName: { label: "", value: "" },
        statePayrollFormsList: [], 
            
    }
});
export const { 
    setFormsList,
    setPayerList,
    setToCreateFormData,
    setIsYearFormTypeSelected,
    setFormBoxesList,
    setFormFieldsList,
    setTempFormFieldsList,
    setRecipientList,
    setLoadingState,
    setRecipientListLoadingState,
    setOnDependentFields,
    setUserInteractionPopupWResponseObj,
    updateUserInteractionPopupWResponseObj,
    resetUserInteractionPopupWResponseObj,
    setFormsPreLoadedData,
     updateFormsPreLoadedData,
    setIsIRSViewOn,
    setReloadFormsPreLoadedData,
    setIsStepperViewAvailable,
    setIsIRSViewAvailable,
    setShouldLoadNextFormInSeries,
    setNxtFormInSeriesDetails,
    setPrevFormInSeriesDetails,
    setFormDataFromRecordId,
    setIsIncorrectFormRecordId,
    setFormsInSeriesHistory,
    setInitialInteractionPopupWObj,
    setGuidedFormList,
    setElementToBeFocused,
    setStepperRefreshStep,
    setHelpTextObj,
    updateHelpTextObj,
    setShowHelpPopup,
    setSelect1099Forms,
    setSelectStatePayrollForms,
    setStateNamesList,
    setSelectedStateName,
    setStatePayrollFormsList,
    
} = actions;